export default {
  items: [
    {
      title: false,
      name: "INICIO",
      url: "/dashboard",
      icon: "icon-speedometer"
    },

    {
      title: false,
      name: "CUENTAS",
      url: "/customers",
      icon: "icon-star"
    },
    {
      title: false,
      name: "DEUDORES",
      url: "/debtors",
      icon: "icon-wallet"
    },
    {
      title: false,
      name: "CARTAS",
      url: "/mainletter",
      icon: "fa fa-files-o"
    },
    {
      title: false,
      name: "INFORMES",
      url: "/informes",
      icon: "fa fa-bullhorn"
    },
    {
      name: "CAMPAÑAS",
      url: "/base",
      icon: "fa fa-paper-plane-o",
      children: [
        {
          name: "CORREOS",
          url: "/CORREOS",
          icon: "fa fa-envelope-o"
        },
        {
          name: "SMS",
          url: "/SMS",
          icon: "fa fa-comments-o"
        }
      ]
    },
    {
      name: "INDICADORES",
      url: "/base",
      icon: "fa fa-bar-chart",
      children: [
        {
          name: "COMERCIAL",
          url: "/base",
          icon: "icon-puzzle",
          children: [
            {
              name: "GENERAL",
              url: "/indicators",
              icon: ""
            },
            {
              name: "ANÁLISIS DE GESTIÓN",
              url: "/managementanalysis",
              icon: ""
            },
            {
              name: "VOLUMEN DE TAREAS",
              url: "/volumetasks",
              icon: ""
            },
            {
              name: "RESUMEN MENSUAL",
              url: "/monthlysummary",
              icon: ""
            },
            {
              name: "COMPORTAMIENTO CLIENTES",
              url: "/customerbehavior",
              icon: ""
            },
            {
              name: "ESTADO DE LA CARTERA",
              url: "/currentwalletstatus",
              icon: ""
            },
            {
              name: "CARTERA",
              url: "/walletindicators",
              icon: ""
            },
            {
              name: "CARTERA POR CLIENTE",
              url: "/prejurycustumerindicators",
              icon: ""
            },
          ]
        },
        {
          name: "PREJURÍDICO",
          url: "/base",
          icon: "icon-puzzle",
          children: [
            {
              name: "ANÁLISIS DE ABONOS",
              url: "/debtor/indicators",
              icon: ""
            },
            {
              name: "CARTERA POR CLIENTE",
              url: "/debtor/prejurycustumerindicators",
              icon: ""
            },
            {
              name: "ANÁLISIS DE GESTIÓN",
              url: "/debtor/managementanalysis",
              icon: ""
            },
            {
              name: "HISTORIAL DE ABONOS",
              url: "/debtor/paymenthistory",
              icon: ""
            },
            {
              name: "CONTEO DE GESTIONES",
              url: "/debtor/managementcount",
              icon: ""
            },
            {
              name: "ANÁLISIS POR TIPIFICACIONES",
              url: "/debtor/analysistypifications",
              icon: ""
            },
            {
              name: "ANÁLISIS POR EDAD DE LA CARTERA",
              url: "/debtor/analysiswalletage",
              icon: ""
            },
            {
              name: "ANÁLISIS DE ABONOS POR SEGMENTOS",
              url: "/debtor/analysissegmentpayments",
              icon: ""
            },
            {
              name: "ANÁLISIS DE ABONOS POR SEGMENTOS (TOTALES)",
              url: "/debtor/analysissegmentpaymentstotals",
              icon: ""
            },
            {
              name: "ABONOS POSIBLES SEGÚN SEGMENTOS",
              url: "/debtor/analysisbalancesrecover",
              icon: ""
            },
            {
              name: "ANÁLISIS DE ABONOS POR CLIENTE",
              url: "/debtor/analysispaymentscustomers",
              icon: ""
            },
            {
              name: "RESUMEN CARTERA POR CLIENTE",
              url: "/debtor/summarypaymentscustomer",
              icon: ""
            },
          ]
        },
        {
          name: "JURÍDICO",
          url: "/base/carousels",
          icon: "icon-puzzle"
        }
      ]
    },
    {
      name: "CALENDARIO",
      url: "/base",
      icon: "fa fa-calendar",
      children: [
        {
          name: "ACTIVIDADES",
          url: "/tasks",
          icon: ""
        },
        {
          name: "CUMPLEAÑOS",
          url: "/birthday",
          icon: ""
        }
      ]
    },
    {
      name: "EXPORTACIÓN",
      url: "/export",
      icon: "fa fa-file-excel-o",
      children: [
        {
          name: "PREJURIDICO",
          url: "/export/prejury",
          icon: ""
        },
        // {
        //   name: "JURIDICO",
        //   url: "/export/jury",
        //   icon: ""
        // }
      ]
    },
    {
      name: "AJUSTES",
      url: "/base",
      icon: "fa fa-cogs",
      children: [
        {
          name: "DIVISAS",
          url: "/currencies",
          icon: ""
        },
        {
          name: "JUZGADOS",
          url: "/judgeds",
          icon: ""
        },
        {
          name: "USUARIOS",
          url: "/users",
          icon: ""
        },
        {
          name: "SUCURSALES",
          url: "/branchoffices",
          icon: ""
        },
        {
          name: "TASA INTERÉS",
          url: "/rateInterests",
          icon: ""
        }
      ]
    }
  ]
};
